export default {
    search_email: 'E-post (som skrevet på din billett)',
    booking_number: 'Billettnr.',
    find: 'Finn billett',
    order_time: 'Bestillingstid',
    total: 'Totalt',
    status: 'Status',
    contact_information: 'Kontaktinformasjon',
    email: 'E-post',
    given_name: 'Fornavn',
    family_name: 'Etternavn',
    address_line_1: 'Adresse',
    postal_code: 'Postnr.',
    locality: 'Poststed',
    country_code: 'Land',
    phone_number: 'Mobilnummer',
    edit: 'Rediger',
    update: 'Oppdater',
    vehicles: 'Kjøretøy',
    read_term: 'Jeg har lest og akseptert',
    term_change: 'Vilkår for billettendring',
    send_order_email: 'Send oppdatert billett på e-post',
    send_order_email_desc: 'Send oppdatert billett på e-post til ',
    send_email: 'Send e-post',
    email_send_success: 'E-post ble sendt',
    email_send_failed: 'Feil ved sending av e-post',
    next_step: 'Neste',
    passengers: 'Passasjerer/kjøretøy',
    confirm_change: 'Bekreft endring',
    change_success: 'Endring var vellykket.',
    change_failed: 'Noe gikk galt under endring.',
    previous_step: 'Tilbake',
    contact_information_desc:'Her kan du endre kontaktinformasjon',
    vehicles_desc:'Her kan du endre merke og modell samt registreringsnummer',
    passengers_desc:'Her kan du redusere antall passasjerer og/eller kjøretøy',
    payment_amount:'Beløpet du må betale er',
    payment_desc: 'Antall reisende for denne billetten endres nå og forårsaker at rabatten fra en gruppebillett med 50 % rabatt endres til en vanlig billett med 25 % rabatt. Det betyr at det må betales ekstra for å dekke prisforskjellen.',
    currency_nok : 'kr',
    error_change_time_passed: 'Bestillingsendringstid har passert.',
    error_booking_number: 'Billettnr. er nødvendig',
    error_email: 'E-post er nødvendig',
    error_order_not_found: 'Vi fant ingen billett på oppgitt informasjon, sjekk billettnummer og/eller epostadressen om det er riktig skrevet, og prøv på nytt.',
    error_agree_term: 'Du har ikke godkjent vilkår for billettendring',
    error_passenger_quantity_exceeded: 'Antall passasjerer/kjøretøy kan ikke økes utover opprinnelig billett.',
    error_passenger_quantity_not_changed: 'Du har ikke utført noen endringer.'
}
